/* tslint:disable:ban-types */

import { PULSE_ELEMENTS_CHUNK } from './model';

export interface IPulseAngularElementProps {
  selector: string;
  chunk: PULSE_ELEMENTS_CHUNK;
}

export interface IPulseAngularElementEntry {
  constructor: Function;
  props: IPulseAngularElementProps;
}

const pulseAngularElements = new Map<string, IPulseAngularElementEntry>();

export function PulseAngularElement(props: IPulseAngularElementProps) {
  return (constructor: Function) => {
    pulseAngularElements.set(props.selector, { constructor, props });
  };
}

export function getPulseAngularElements() {
  return pulseAngularElements;
}

export function getPulseAngularElementsForChunk(chunk: PULSE_ELEMENTS_CHUNK) {
  const arr: { constructor: Function; selector: string }[] = [];
  pulseAngularElements.forEach(({ constructor, props }) => {
    if (props.chunk === chunk) {
      arr.push({ constructor, selector: props.selector });
    }
  });
  return arr;
}

export function dangerouslyClearAngularElementsRegistry() {
  pulseAngularElements.clear();
}
